<template>
  <div class="article-typo" ref="richText" v-html="richContent"></div>
</template>
<script>
import vueTypes from 'vue-types'
import utils from '../../utils'
import hljs from '../../utils/highlight-line-number'
import 'highlight.js/styles/github-gist.css'
import Hls from 'hls.js'
const hls = new Hls()

export default {
  name: 'rich-content',
  props: {
    title: vueTypes.string.def(''),
    content: vueTypes.string.def('')
  },
  data () {
    return {}
  },
  inject: ['info'],
  computed: {
    richContent () {
      let content = this.content
      const regHref = /(<a.*?\bhref\b=")(.*?)(".*?)(>.*?<\/a>)/gi
      const regInfoq = /\binfoq\b\.\bcn\b/

      content = content.replace(regHref, ($0, $1, $2, $3, $4) => {
        return regInfoq.test($2) ? $0 : `${$1}${$2}${$3} rel="noopener nofollow"${$4}`
      })

      return utils.formatContent(content)
    }
  },
  watch: {
    content: {
      handler: function (val, old) {
        // this.richContent = utils.formatContent(val)

        this.$nextTick(() => {
          this.initHighLightCode()
          this.initHref()
        })
      },
      immediate: true
    },
    richContent (val, oldVal) {
      this.handleMathJax(val)
    }
  },
  mounted () {
    this.initCodeCopy()
    this.initHighLightCode()
    this.handleMathJax(this.richContent)
    this.initVideo()
    this.initImageAlt()
  },
  methods: {
    /**
     * 给图片添加 alt
     */
    initImageAlt () {
      if (!this.title) {
        return
      }

      let imgs = this.$el.querySelectorAll('img')

      imgs.forEach(img => {
        img.setAttribute('alt', this.title)
      })
    },
    /**
     * 解析数学公式
     */
    handleMathJax (content = '') {
      // 数学公式，如果正文里包含 $ 则加载 MathJax 脚本
      if (content.indexOf('$') > -1) {
        utils.handleMathJax(this.$el)
      }
    },
    /**
     * 初始化复制代码功能
     */
    initCodeCopy () {
      let pres = this.$el.querySelectorAll('pre')
      pres.forEach(pre => {
        let parent = pre.parentNode
        let code = pre.querySelector('code')
        const textContent = code.textContent
        let copyBtn = document.createElement('div')
        copyBtn.innerHTML = `<div class="copy"><span class="iconfont">&#xe676;</span>复制代码<div class="tooltip"></div></div>`
        copyBtn.classList.add('tool')
        parent.insertBefore(copyBtn, pre)
        copyBtn.addEventListener('click', e => {
          let tooltipNode = copyBtn.querySelector('.tooltip')
          let input = document.createElement('textarea')
          let top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
          input.setAttribute('readonly', 'readonly') // 防止 iPhone 弹出键盘
          input.style.position = 'absolute' // 防止 Firefox Edge 滚动到页面最下方
          input.style.top = `${top + 256}px`
          input.style.opacity = '0'
          document.body.appendChild(input)
          input.textContent = textContent
          input.focus()
          input.setSelectionRange(0, input.textContent.length)
          tooltipNode.innerHTML = document.execCommand('copy') ? '已复制' : '复制失败'
          tooltipNode.classList.add('show')
          setTimeout(() => {
            tooltipNode.classList.remove('show')
          }, 1500)
          document.body.removeChild(input)
        })
      })
    },
    /**
     * 高亮代码块
     */
    initHighLightCode () {
      let blocks = this.$el.querySelectorAll('pre code')
      blocks.forEach(block => {
        hljs.highlightBlock(block)
        hljs.lineNumbersBlock(block, { singleLine: true })
      })
    },
    initVideo () {
      const videos = this.$refs.richText.querySelectorAll('video')
      if (videos.length > 0) {
        Array.prototype.slice.call(videos).forEach(video => {
          let poster = video.attributes.poster
          poster = poster ? poster.value : ''
          const parent = video.parentElement
          const container = document.createElement('div')
          const src = video.lastChild.attributes.src.value
          container.innerHTML = `<video style="vertical-align: top;" ref="video" webkit-playsinline playsinline x5-playsinline x5-video-player-type="h5" x5-video-player-fullscreen="true" src="${src}" controls="controls" poster="${poster}"></video>`
          parent.insertBefore(container, video)
          parent.removeChild(video)
          const newVideo = parent.querySelector('video')
          hls.loadSource(src)
          hls.attachMedia(newVideo)
        })
      }
    },
    initHref () {
      // const hrefs = this.$refs.richText.querySelectorAll('a')
      // if (hrefs.length > 0) {
      //   Array.prototype.slice.call(hrefs).forEach(href => {
      //     const src = video.lastChild.attributes.src.value
      //   })
      // }
      const ATags = this.$refs.richText.querySelectorAll('a')

      for (let i = 0; i < ATags.length; i++) {
        const EachTag = ATags[i]
        const href = EachTag.href
        if (href.indexOf('google://download') > -1) {
          // EachTag.target = 'javascript:void(0)'
          // if (href.indexOf('?') > -1) href = href.split('?')[0]
          let url = utils.getQueryString(href, 'url')
          let filename = utils.getQueryString(href, 'name')
          let fileType = utils.getFileType(url)
          const flieArr = url.split('?')[0].split('.')
          const suffix = flieArr[flieArr.length - 1]

          EachTag.onclick = () => {
            // 添加下载 PDF 的逻辑
            utils.downloadfile(url, `${filename || 'GoogleFile'}.${suffix}`, fileType)
            // 添加 GA
            // window.gtag && window.gtag('event', `Google文章详情页下载统计`, {
            //   'send_to': 'UA-160408832-1',
            //   'article_id': `${Number(this.info.aid)}`,
            //   'filename': filename
            // })
            utils.GA('send', 'event', `Google文章详情页下载统计`, `${Number(this.info.aid)}`, filename)
            return false
          }
        }
      }
    }
  }
}
</script>
